import * as React from "react";
import { Panel } from "react-bootstrap";

import OtherIncomeSection from "./OtherIncomeSection";

interface IAdditionalIncomeForBorrowerProps {
  additionalIncomes: any;
  setDocId?: Function;
  incomeDocs: Function;
  header: string;
  handleChange?: Function;
  hasCoborrower: boolean;
}

class AdditionalIncomeForBorrower extends React.Component<IAdditionalIncomeForBorrowerProps, any> {
  handleAdditionalIncomeChange(incomeID, prop, value) {
    this.props.handleChange(incomeID, prop, value);
  }

  render() {
    const { additionalIncomes, setDocId, header } = this.props;
    return (
      <Panel bsStyle="info" defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>{header}</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {additionalIncomes.map((income, i) => (
              <OtherIncomeSection
                key={i}
                income={income}
                setDocId={setDocId.bind(this)}
                docs={this.props.incomeDocs(income.id)}
                onChange={this.handleAdditionalIncomeChange.bind(this, income.id)}
                hasCoborrower={this.props.hasCoborrower}
              />
            ))}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default AdditionalIncomeForBorrower;
